// Tenantra Inc. - This month's rent split into Paid / Processing / Not due yet / Overdue / Awaiting report (click a tile to see who)
import { Card, STATUS_LABEL, fmtDate, money, plural } from './kit';

const TILES = [
  ['paid', 'bg-teal-600', 'text-teal-700'], ['processing', 'bg-sky-400', 'text-sky-700'], ['unpaid', 'bg-slate-300', 'text-slate-600'],
  ['overdue', 'bg-red-500', 'text-red-700'], ['unreported', 'bg-amber-400', 'text-amber-700'],
];

export function CollectionStatus({ data, onDrill }) {
  const { totals, expected, rows, label } = data;
  const tiles = TILES.filter(([k]) => k !== 'unreported' || totals.unreported.count > 0);
  const open = (k) => onDrill({
    crumb: `${label} rent`, title: STATUS_LABEL[k],
    rows: rows.filter(r => r[k] > 0.005).map(r => ({ key: r.tenancy_id, tenant_id: r.tenant_id, primary: r.tenant, secondary: `${r.where} · due ${fmtDate(r.due_date)}`, value: money(r[k]), amount: r[k] })),
  });
  return (
    <Card title={`${label} collection`} aside={`${money(expected)} rent due`} testId="collection-status">
      <div className="px-5">
        <div className="h-2 rounded-full bg-slate-100 overflow-hidden flex" data-testid="collection-status-bar">
          {tiles.map(([k, bg]) => totals[k].amount > 0 && <div key={k} className={`${bg} h-full transition-[width] duration-500`} style={{ width: `${(totals[k].amount / (expected || 1)) * 100}%` }} />)}
        </div>
      </div>
      <div className={`grid grid-cols-2 ${tiles.length === 5 ? "sm:grid-cols-5" : "sm:grid-cols-4"} gap-px mt-3`}>
        {tiles.map(([k, bg, text]) => (
          <button key={k} type="button" onClick={() => open(k)} className="text-left px-5 py-3 hover:bg-slate-50/80 transition-colors rounded-md" data-testid={`collection-status-${k}`}>
            <p className="text-xs text-slate-500 inline-flex items-center gap-1.5"><span className={`w-2 h-2 rounded-full ${bg}`} />{STATUS_LABEL[k]}</p>
            <p className={`text-lg font-medium tabular-nums mt-0.5 ${totals[k].amount > 0 ? text : 'text-slate-300'}`}>{money(totals[k].amount)}</p>
            <p className="text-[11px] text-slate-400">{plural(totals[k].count, 'tenant')}</p>
          </button>
        ))}
      </div>
      {totals.unreported.count > 0 && <p className="px-5 pb-3 text-[11px] text-slate-400">Awaiting report: rent you collect yourself shows here until you file this month's report.</p>}
    </Card>
  );
}
